import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'

const defaultOptions = {
  transformed: true,
  response: false,
  filter: () => true,
  // filter: (key, value) => true,
  stateModify: true,
  loaders: () => {},
  // loaders: vm => {},
}

function errorsFromLaravel(errors, filter) {
  const newErrors = {}
  if (typeof filter !== 'function') filter = () => true
  Object.keys(errors).map((key) => {
    const newKey = key.replace(/^[0-9]\d*$/g, function (macthed) {
      return '[' + macthed + ']'
    })

    const value = Array.isArray(errors[key]) ? errors[key][0] : errors[key]
    if (filter(newKey, value)) {
      _.set(newErrors, newKey, value)
    }
  })
  return newErrors
}

// Wrapper for ajax request with axios
const request = async function (callback, errorCallback = false, overwriteOptions = {}) {
  let isCancel = false
  const error = (msg) => this.$store.getters.is_dev && console.error(`Error on request, component ${this.$options.name} \n\n`, msg)

  // Set default options
  const options = { ...defaultOptions }
  if (typeof overwriteOptions === 'object') Object.assign(options, overwriteOptions)
  try {
    // Await for ajax call
    await callback()
  } catch (e) {
    // Check if request is canceled or component is destroyed
    isCancel = this._isBeingDestroyed || this._isDestroyed || axios.isCancel(request)

    // Set return item
    if (typeof errorCallback === 'function' && !isCancel && e.request && e.request.response) {
      let errors = []
      const response = JSON.parse(e.request.response)
      if (options.reponse) {
        // Set full error response on demand
        errors = response
      } else {
        // Transform errors from laravel

        if (typeof options.loaders !== 'function') {
          error('The option loaders is not an function')
        } else errors = options.transformed ? errorsFromLaravel(response.errors, options.filter) : response.errors
      }

      errorCallback(errors)
    }
    // Show error bad code
    if (!(isCancel || e.request)) {
      error(e)
    }
  } finally {
    // On cancel or not wanting to modify the state return item and don't modify state of actions
    // eslint-disable-next-line no-unsafe-finally
    if (isCancel || !options.stateModify) return

    // Modify actions to false
    if (this.isSaving) this.isSaving = false
    if (this.isLoading) this.isLoading = false
    if (this.isSearching) this.isSearching = false
    if (this.isTabLoading) this.isTabLoading = false

    if (typeof options.loaders !== 'function') {
      error('The option loaders is not an function')
    } else options.loaders(this)
  }
}

Vue.prototype.$req = request
